export const UPDATE_DMX_DEVICE = 'UPDATE_DMX_DEVICE';
export const UPDATE_DMX_DEVICE_SUCCESSFUL = 'UPDATE_DMX_DEVICE_SUCCESSFUL';
export const UPDATE_DMX_DEVICE_FAILED = 'UPDATE_DMX_DEVICE_FAILED';
